import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import ColorPicker from "../../../common/components/Select/ColorPicker/ColorPicker";
import { LayerModel } from "../specsModel/LayerModel";
import { INHERITED_COLOR_LABEL } from "./styles";

export function LayerColorPicker({
  color,
  onChange,
}: {
  color: string;
  onChange: (hex: string) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const inherited = LayerModel.isInheritedColor(color);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 0.5 }}>
      <Box
        onClick={(e) =>
          inherited
            ? undefined
            : setAnchorEl(open ? null : (e.currentTarget as HTMLElement))
        }
        sx={{
          width: 24,
          height: 24,
          borderRadius: "4px",
          bgcolor: inherited ? "grey.100" : color,
          border: inherited
            ? "1px dashed rgba(0,0,0,0.45)"
            : "1px solid rgba(0,0,0,0.15)",
          cursor: inherited ? "default" : "pointer",
          flexShrink: 0,
          "&:hover": { boxShadow: "0 0 0 2px rgba(0,0,0,0.1)" },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontSize: "11px",
          fontFamily: "monospace",
          color: "text.secondary",
          userSelect: "all",
        }}
      >
        {inherited ? INHERITED_COLOR_LABEL : color}
      </Typography>
      {inherited ? null : (
        <ColorPicker
          isOpen={open}
          anchorEl={anchorEl}
          value={color}
          onColorChange={onChange}
          onClose={() => setAnchorEl(null)}
          width="220px"
        />
      )}
    </Stack>
  );
}
